import type { Questionnaire } from '@medplum/fhirtypes'

export const PatientPhysicalFunctioningQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/patient-physical-functioning',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Patient Physical Functioning',
  title: 'Physical Functioning',
  item: [
    {
      linkId: 'mobility',
      text: 'Mobility',
      type: 'string',
    },
    {
      linkId: 'physical-functioning-daily-living',
      text: 'Physical functioning, including activities of daily living',
      type: 'string',
    },
    {
      linkId: 'pain-management',
      text: 'Pain management',
      type: 'string',
    },
    {
      linkId: 'dme-sensory-equipment',
      text: 'DME and Sensory Equipment',
      type: 'string',
    },
  ] as const,
} satisfies Questionnaire
